module.exports = __webpack_public_path__ + "static/img/3@2x.f870da46.png";